import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Experience = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="experience" id="skills">
        <div className="container">
            <div className="row" style={{marginBottom:"40px"}}>
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Personal & professional👩‍💻 Information</h2>
                        <p>Personal details</p>
                        <h3>Full Name : Kavyashree H patwardhan</h3>
                        <h3>Date of Birth       :         22/12/1999</h3>
                        <h3>Education : BCA</h3>
                        <p>professional👩‍💻 details</p>
                        <h3>Previously worked at: Infosys Ltd</h3>
                        <h3>Role: Operations executive</h3>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image"  style={{marginTop:"20"}} />
    </section>
  )
}